import { withUrlPrefix } from "@/js/helpers";

export class PropertyService {
    /**
     * この県の物件をすべて取得する。
     *
     * 母集団は県ぶん全部で、地図を開いたときに1回だけ呼ぶ（移動・ズームでは取り直さない）。
     * 1県の在庫は多くても数十件なので、ピンの出し入れも初期中心の計算もブラウザ側で足りる。
     * そこへ一覧から引き継いだ絞り込み条件（このページ自身のクエリ文字列）を重ねて送り、
     * 一覧と同じ絞り込みが地図上でも効くようにする。
     * 条件キーの意味はサーバー側（EstateCondTrait）が持つので、ここでは解釈も再構築もしない
     * （条件が増えてもJS側の追随は不要）
     */
    static async fetchProperties(type = "all") {
        const params = new URLSearchParams(window.location.search);

        // APIのルートは県の外にあるので、地図ページが meta で受け取った県キーを添える
        const siteArea = document
            .querySelector('meta[name="map-site-area"]')
            ?.getAttribute("content");
        if (siteArea) params.set("site_area", siteArea);

        // 本番は /bunjo 配下で配信される。ここは route() を通らず自前でパスを組むため接頭辞を足す
        const response = await fetch(
            withUrlPrefix(`/api/search/map/type/${type}?${params.toString()}`)
        );
        if (!response.ok) throw new Error(`APIエラー: ${response.status}`);

        const data = await response.json();
        // 0件は「条件に合う物件が県内に無い」という正しい結果なので、そのまま空配列を返す
        return Array.isArray(data.items) ? data.items : [];
    }

    // idsによって物件カードのHTMLを取得
    static async fetchPropertiesByIds(ids, type = "buy") {
        const params = new URLSearchParams();
        ids.forEach((id) => params.append("id[]", id));

        const response = await fetch(
            withUrlPrefix(`/api/search/map-cards/id?${params.toString()}&type=${type}`)
        );
        if (!response.ok) throw new Error(`APIエラー: ${response.status}`);

        return await response.text();
    }
}

export default PropertyService;
